@if (location == null) {
    <div class="TotemWidget TotemWidgetWeather card">Location missing</div>
}

@if (location != null) {
    @if (!fullScreen) {
        <div class="TotemWidget TotemWidgetWeather card" role="button" tabindex="0" [attr.aria-label]="'totem-a11y.open-details' | locTranslate" (click)="requestFullScreen.emit()" (keydown)="onCardKeydown($event)">
            <div class="card-body">
                <div>
                    @if (offset == null || offset <= 0) {
                        @if (currentWeatherData == null) {
                            <div>
                                <app-pg-loading [isOverlay]="true"></app-pg-loading>
                            </div>
                        }
                        @if (currentWeatherData != null) {
                            <ng-container *ngTemplateOutlet="weatherDisplayTemplate;context:{ 
                                background: 'url(' + currentWeatherData.getImage() + ')',
                                display: currentWeatherData.getDisplay(), 
                                description: currentWeatherData.getDescription(), 
                                location: formatLocation(location),
                                temperature: { curr: currentWeatherData.getTemperature() },
                                humidity: currentWeatherData.main.humidity,
                                aqi: getAirQualityIndex(currentAirQualityData), 
                                vertical: false 
                            }"></ng-container>
                        }
                    }
                    @if (offset != null && offset > 0) {
                        @if (forecastWeatherData == null || forecastWeatherData[offset] == null) {
                            <div>
                                <app-pg-loading [isOverlay]="true"></app-pg-loading>
                            </div>
                        }
                        @if (forecastWeatherData && forecastWeatherData[offset]; as forecast) {
                            <ng-container *ngTemplateOutlet="weatherDisplayTemplate;context:{ 
                                background: 'url(' + forecast.getImage() + ')',
                                date: getForecastDate(offset),
                                display: forecast.getDisplay(), 
                                description: forecast.getDescription(), 
                                location: formatLocation(location),
                                temperature: { min: forecast.getTemperature('min'), max: forecast.getTemperature('max') },
                                humidity: forecast.getHumidity(),
                                vertical: false 
                            }"></ng-container>
                        }
                    }
                </div>
            </div>
        </div>
    }
    @if (fullScreen) {
        <div class="TotemWidget TotemWidgetWeather TotemWidgetWeather--FullScreen">
            <div class="pb-3">
                <div class="row">
                    <div class="col-12 col-md-5 col-lg-3">
                        <div class="card TotemWidgetWeather-CurrentWeather mb-3">
                            @if (currentWeatherData == null) {
                                <div>
                                    <app-pg-loading [isOverlay]="true"></app-pg-loading>
                                </div>
                            }
                            @if (currentWeatherData != null) {
                                <ng-container *ngTemplateOutlet="weatherDisplayTemplate;context:{ 
                                    background: 'url(' + currentWeatherData.getImage() + ')',
                                    date: getForecastDate(0),
                                    display: currentWeatherData.getDisplay(), 
                                    description: currentWeatherData.getDescription(), 
                                    location: formatLocation(location),
                                    temperature: { curr: currentWeatherData.getTemperature() },
                                    humidity: currentWeatherData.main.humidity,
                                    aqi: getAirQualityIndex(currentAirQualityData), 
                                    vertical: true 
                                }"></ng-container>
                            }
                        </div>
                    </div>
                    <div class="col-12 col-md-7 col-lg-9 TotemWidgetWeather-ForecastWeather">
                        @if (forecastWeatherData == null) {
                            <div>
                                <app-pg-loading [isOverlay]="true"></app-pg-loading>
                            </div>
                        }
                        @if (forecastWeatherData != null) {
                            <div>
                                <div class="row">
                                    @for (offset of [1,2,3,4,5,6]; track offset) {
                                        <div class="col-12 col-lg-6">
                                            @if (forecastWeatherData[offset]; as forecast) {
                                                <div class="card">
                                                    <div class="card-body">
                                                        <ng-container *ngTemplateOutlet="weatherDisplayTemplate;context:{ 
                                                            date: getForecastDate(offset), 
                                                            display: forecast.getDisplay(), 
                                                            description: forecast.getDescription(), 
                                                            temperature: { min: forecast.getTemperature('min'), max: forecast.getTemperature('max') },
                                                            humidity: forecast.getHumidity(),
                                                            vertical: false 
                                                        }"></ng-container>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div class="row pt-3">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="text-center mb-2">{{ 'totem-widget-weather.today-forecast' | locTranslate }}</h5>
                                @if (weatherGraphDataset == null) {
                                    <app-pg-loading [isOverlay]="true"></app-pg-loading>
                                }
                                @if (weatherGraphDataset != null) {
                                    <app-pg-graph [dataSet]="weatherGraphDataset" graphMode="Line" [smooth]="true"></app-pg-graph>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}

<ng-template #weatherDisplayTemplate let-background="background" let-display="display" let-description="description" let-temperature="temperature" let-humidity="humidity" let-aqi="aqi" let-date="date" let-location="location" let-vertical="vertical">
    <div [style.backgroundImage]="background" class="TotemWidgetWeather-Display {{background != null ? 'TotemWidgetWeather-Display--WithBackground' : ''}}">
        <div class="{{ vertical ? 'px-3' : 'py-3' }}">
            @if (vertical && date != null) {
                <h6 class="text-center m-0" [innerHTML]="date"></h6>
            }
            <div class="TotemWidgetWeather-Display-Main">
                @if (!vertical && date != null) {
                    <h6 class="text-center m-0" [innerHTML]="date"></h6>
                }
                <div>
                    <div [innerHTML]="display | safe:'html'"></div>
                    <div>{{description}}</div>
                </div>
                @if (!vertical && location != null) {
                    <div class="TotemWidgetWeather-Display-Location">{{location}}</div>
                }
            </div>
            <div class="TotemWidgetWeather-Display-Side">
                @if (temperature != null) {
                    @if (temperature.min != null) {
                        <div class="TotemWidgetWeather-Display-Side-Item">
                            <span><i class="fa-regular fa-temperature-empty" aria-hidden="true"></i></span>
                            <span>{{temperature.min}}° C</span>
                        </div>
                    }
                    @if (temperature.curr != null) {
                        <div class="TotemWidgetWeather-Display-Side-Item">
                            <span><i class="fa-regular fa-temperature-half" aria-hidden="true"></i></span>
                            <span>{{temperature.curr}}° C</span>
                        </div>
                    }
                    @if (temperature.max != null) {
                        <div class="TotemWidgetWeather-Display-Side-Item">
                            <span><i class="fa-regular fa-temperature-full" aria-hidden="true"></i></span>
                            <span>{{temperature.max}}° C</span>
                        </div>
                    }
                }
                <div class="TotemWidgetWeather-Display-Side-Item">
                    <span><i class="fa-regular fa-droplet" aria-hidden="true"></i></span>
                    <span>{{humidity}}%</span>
                </div>
                @if (aqi != null) {
                    <div class="TotemWidgetWeather-Display-Side-Item">
                        <span><span>AQ</span></span>
                        <span>{{aqi}}</span>
                    </div>
                }
            </div>
            @if (vertical && location != null) {
                <div class="TotemWidgetWeather-Display-Location">{{location}}</div>
            }
        </div>
    </div>
</ng-template>